import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import {
	IPropsAutomationWheelhouseProperties,
	IResponseAutomationWheelhouseProperties,
} from "./types"
import { useApi } from "../../useApi"
import { UpdateAutomationWheelhousePropertiesURL } from "../../../utils/constants"

async function putAutomationWheelhouseProperties(
	data: IPropsAutomationWheelhouseProperties,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseAutomationWheelhouseProperties> =
			await apiPrivate.put(`${UpdateAutomationWheelhousePropertiesURL}`, data)

		return response
	} catch (error: any) {
		return error.response
	}
}

export function usePutAutomationWheelhouseProperties(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseAutomationWheelhouseProperties>,
					unknown,
					unknown,
					AxiosResponse<IResponseAutomationWheelhouseProperties>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsAutomationWheelhouseProperties) =>
			putAutomationWheelhouseProperties(data, apiPrivate),
		...options,
	})
	return mutation
}
